export default __webpack_public_path__ + "static/13_32-dcbc309c75a657a6594b9ce8d5c59836.png";